interface Options {
  body?: Record<string, any>;
  method?: "GET" | "POST" | "PUT" | "DELETE";
}

export async function customFetch(uri: string, options?: Options) {
  let method = "GET";
  let body;

  if (options?.method) {
    method = options.method;
  }

  if (options?.body) {
    body = JSON.stringify(options.body);
  }

  if (!window || !("shopify" in window)) {
    throw new Error("Shopify object is not available");
  }

  // @ts-ignore
  const idToken = await window.shopify.idToken();

  const stream = await fetch(uri, {
    method,
    body,
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${idToken}`,
    },
  });
  const response = await stream.json();

  return response;
}
